export default "__VITE_ASSET__bf7f414a__"